import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _CreateBankModal;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Checkbox } from '@instructure/ui-checkbox';
import { View } from '@instructure/ui-view';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import Bank from '../../../common/records/Bank';
import { toErrors } from '../../../common/util/instUIMessages';
import { Modal, ModalHeader, ModalBody, ModalFooter, TextInput, XSMALL_SIDE_MARGIN } from '@instructure/quiz-common';
export var CreateBankModal = /*#__PURE__*/function (_Component) {
  function CreateBankModal(props) {
    var _this;
    _classCallCheck(this, CreateBankModal);
    _this = _callSuper(this, CreateBankModal, [props]);
    _defineProperty(_this, "state", {
      shareWithCourse: false
    });
    _defineProperty(_this, "continueAction", function () {
      _this.props.showError(_this.props.errorKey);
      if (_this.props.temporaryBank.isValid()) {
        var courseUuid = _this.state.shareWithCourse ? _this.props.itemBanksScope.uuid : null;
        _this.props.createBank(_this.props.temporaryBank, courseUuid);
        _this.props.onCreateBank();
        _this.closeAction();
      } else {
        var _this$bankNameInput$c;
        (_this$bankNameInput$c = _this.bankNameInput.current) === null || _this$bankNameInput$c === void 0 || _this$bankNameInput$c.focus();
      }
    });
    _defineProperty(_this, "closeAction", function () {
      _this.props.hideError(_this.props.errorKey);
      _this.setState({
        shareWithCourse: false
      });
      _this.props.clearModifications('banks', _this.props.temporaryBank.id);
      if (_this.props.modalTrigger) {
        _this.props.modalTrigger.focus();
      }
      _this.props.closeModal();
    });
    _defineProperty(_this, "onNameChange", function (e) {
      _this.props.showError(_this.props.errorKey);
      _this.props.changeBank(_this.props.temporaryBank.id, {
        title: e.target.value
      });
    });
    _defineProperty(_this, "getErrors", function () {
      if (_this.props.displayError) {
        return toErrors(_this.props.temporaryBank.errorsFor('title').toJS());
      }
    });
    _defineProperty(_this, "toggleCheckbox", function (event) {
      _this.setState({
        shareWithCourse: event.target.checked
      });
    });
    _this.bankNameInput = React.createRef();
    return _this;
  }
  _inherits(CreateBankModal, _Component);
  return _createClass(CreateBankModal, [{
    key: "cancelButton",
    value: function cancelButton() {
      return jsx(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN
      }, t('Cancel'));
    }
  }, {
    key: "createBankButton",
    value: function createBankButton() {
      return jsx(Button, {
        type: "button",
        color: "primary",
        onClick: this.continueAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-create-bank-button"
      }, t('Create Bank'));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return jsx("div", null, jsx(TextInput, {
        messages: this.getErrors(),
        onChange: this.onNameChange,
        renderLabel: t('Bank Name'),
        isRequired: true,
        type: "text",
        "data-automation": "sdk-create-bank-name-textinput",
        ref: this.bankNameInput
      }), this.renderCheckbox());
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {
      var hide = !this.props.showShareBankOnCreate || this.props.itemBanksScope.type !== 'course' || !this.props.itemBanksScope.title || !this.props.itemBanksScope.uuid;
      if (hide) {
        return null;
      }
      var label = t('Share with { courseName }', {
        courseName: this.props.itemBanksScope.title
      });
      return jsx(View, {
        margin: "medium 0 0 0",
        as: "div"
      }, jsx(Checkbox, {
        label: label,
        checked: this.state.shareWithCourse,
        onChange: this.toggleCheckbox
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: "small",
        label: t('Item Bank'),
        "data-automation": "sdk-create-bank-modal"
      }, jsx(ModalHeader, null, jsx(Heading, {
        as: "h2"
      }, t('New Item Bank')), jsx(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderContent()), jsx(ModalFooter, null, this.cancelButton(), this.createBankButton()));
    }
  }]);
}(Component);
_CreateBankModal = CreateBankModal;
_defineProperty(CreateBankModal, "displayName", 'CreateBankModal');
_defineProperty(CreateBankModal, "componentId", "Quizzes".concat(_CreateBankModal.displayName));
_defineProperty(CreateBankModal, "propTypes", {
  modalOpen: PropTypes.bool.isRequired,
  modalTrigger: PropTypes.instanceOf(Component),
  temporaryBank: PropTypes.instanceOf(Bank).isRequired,
  displayError: PropTypes.bool,
  errorKey: PropTypes.string.isRequired,
  createBank: PropTypes.func.isRequired,
  changeBank: PropTypes.func.isRequired,
  clearModifications: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  hideError: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  onCreateBank: PropTypes.func,
  showShareBankOnCreate: PropTypes.bool,
  itemBanksScope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  }),
  styles: PropTypes.object
});
_defineProperty(CreateBankModal, "defaultProps", {
  displayError: false,
  modalTrigger: null,
  showShareBankOnCreate: false,
  itemBanksScope: {},
  onCreateBank: function onCreateBank() {}
});
export default CreateBankModal;